<template>
	<div>
		<div v-if="components && components.length">
			<component v-for="(component, index) in components" :key="index" :is="component" :data="data"></component>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import metricsService from '../../../src/services/metricsService.js';
import { defineAsyncComponent, markRaw } from 'vue';
export default {
	props: {
		location: String,
		data: Object,
	},
	data() {
		return {
			components: [],
		};
	},
	computed: {
		...mapState({
			plugins: (state) => state.plugin.plugins,
		}),
	},
	methods: {
		async updateComponents() {
			const pluginComponents = import.meta.glob('../../*/web/components/*.vue');

			if (!this.plugins || !this.plugins.length) return;
			const metricName = `PluginHook-Load-${this.location}`;
			metricsService.startTracking(metricName);
			this.components = [];

			const activePlugins = this.plugins.filter((plugin) => !plugin.deleted && plugin.isActive);

			if (activePlugins.length === 0) {
				metricsService.endTracking(metricName, 'PluginHook.vue');
				return;
			}

			for (const plugin of activePlugins) {
				const path = `../../${plugin.key}/web/components/${this.location}.vue`;

				if (!pluginComponents[path]) {
					continue;
				}

				// Wrap loader to intercept completion
				const asyncComp = defineAsyncComponent({
					loader: pluginComponents[path],
				});

				this.components.push(markRaw(asyncComp));
			}

			// Schedule single endTracking call after DOM renders active components
			this.$nextTick(() => {
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						metricsService.endTracking(metricName, 'PluginHook.vue');
					});
				});
			});
		},
	},

	async mounted() {
		await this.updateComponents();
	},
	watch: {
		plugins: {
			immediate: true,
			handler() {
				this.updateComponents();
			},
		},
	},
};
</script>

<style scoped></style>
